import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Row,
} from "reactstrap";
import {
  createMessageMeeting,
  ListMessageMeeting,
  updateInPerson,
} from "../../../../components/Header/Data3";
import moment from "moment";
import { useSocket } from "../../../../contexts/SocketContext";
import {
  addIncomingMessage,
  setOppertunity,
  setOppertunityStage,
  updateSelectedConvoFields,
} from "../../../../redux/slices/MsgSlice";
import { useNavigate } from "react-router-dom";

const InPersonMeetingModal = ({
  isOpen,
  closeModal,
  updateInPersonMeeting,
  meetingData,
  setUpdateInPersonMeeting,
}) => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [meetingDetails, setMeetingDetails] = useState({
    meetingTitle: "",
    Address: "",
    date: "",
    time: "",
    notes: "",
  });
  const logUser = user?.Role;
  // const logUser = localStorage.getItem("USER_ROLE");
  const { selectedConvo } = useSelector((state) => state.messages);
  const { sendNewMessage, updateCurrentParent } = useSocket();
  const handleChange = (event) => {
    const { name, value } = event.target;
    setMeetingDetails({ ...meetingDetails, [name]: value });
  };
  useEffect(() => {
    if (user) {
      setMeetingDetails({ ...meetingDetails, Address: user?.Address });
    }
    if (updateInPersonMeeting === "Update") {
      setMeetingDetails({
        meetingTitle: meetingData?.title,
        Address: meetingData?.address,
        date: moment(meetingData?.schedule_date).format("YYYY-MM-DD"),
        time: moment(meetingData?.schedule_time, "hh:mm A").format("HH:mm"),
        notes: meetingData?.note,
      });
    }
  }, [isOpen, updateInPersonMeeting]);
  console.log(meetingData, "meetingData");
  const handleSubmit = async () => {
    setSubmitting(true);
    if (!meetingDetails.meetingTitle) {
      toast.error("Please enter meeting title");
      return;
    }
    if (!meetingDetails.Address) {
      toast.error("Please enter meeting address");
      return;
    }
    if (!meetingDetails.date) {
      toast.error("Please enter meeting date");
      return;
    }
    if (!meetingDetails.time) {
      toast.error("Please enter meeting time");
      return;
    }
    const sender = user.UserID;
    const receiver =
      selectedConvo.createdBy === user.UserID
        ? selectedConvo.customerId
        : selectedConvo.createdBy;
    let formData = {
      Title: meetingDetails.meetingTitle,
      messageId: selectedConvo.Id,
      meetingDate: moment(meetingDetails.date).format("MMMM DD, YYYY"),
      meetingTime: moment(meetingDetails.time, "HH:mm").format("hh:mm A"),
      Address: meetingDetails.Address,
      createdBy: sender,
      receivedBy: receiver,
      meetingStatus: "Pending",
      Note: meetingDetails.notes,
      customerId: receiver,
      postId: selectedConvo.postId,
      messageStatus: 15, // status for In-person meeting
      zoomStatus: 8, //create In-person meeting
      postId: selectedConvo.Id,
    };
    try {
      const response = await createMessageMeeting(formData);
      const updateCurrent = {
        messageStatus: 15,
        zoomStatus: 8,
      };
      dispatch(updateSelectedConvoFields(updateCurrent));
      updateCurrentParent({
        ...updateCurrent,
        Id: selectedConvo.Id,
      });
      if (response) {
        sendNewMessage(response.Data);
        dispatch(addIncomingMessage(response.Data));
      }
      // setSubmitting(false);
    } catch (error) {
      console.error(error);
    }
    setMeetingDetails({
      meetingTitle: "",
      Address: "",
      date: "",
      time: "",
      notes: "",
    });
    dispatch(setOppertunity(6));
    dispatch(setOppertunityStage(true));
    setSubmitting(false);
    selectedConvo?.createdBy !== user?.UserID &&
      logUser !== "provider" &&
      toast.success("In-Person Meeting Request sent");
    // if (selectedConvo?.createdBy === user?.UserID && logUser === "provider") {
    //   handleAcceptMeeting();
    // }
    closeModal();
  };

  const handleAcceptMeeting = async () => {
    let Id = meetingData?.id;
    const receiver =
      selectedConvo.createdBy === user.UserID
        ? selectedConvo.customerId
        : selectedConvo.createdBy;
    let formData = {
      Title: meetingDetails.meetingTitle,
      messageId: meetingData?.message_id,
      meetingDate: moment(meetingDetails.date).format("MMMM DD, YYYY"),
      meetingTime: moment(meetingDetails.time, "HH:mm").format("hh:mm A"),
      Address: meetingDetails.Address,
      // createdBy: meetingData.created_by,
      createdBy: user?.UserID,
      receivedBy: receiver,
      // receivedBy: meetingData.received_by,
      meetingStatus: "Accepted",
      Note: meetingDetails.notes,
      customerId: selectedConvo?.customerId,
      postId: selectedConvo?.Id,
      messageStatus: 18, // status for In-person meeting
      zoomStatus: 10, //create In-person meeting
    };
    await updateInPerson(Id, formData);
    const updateCurrent = {
      messageStatus: 18,
      zoomStatus: 10,
    };
    dispatch(updateSelectedConvoFields(updateCurrent));
    updateCurrentParent({
      ...updateCurrent,
      Id: selectedConvo.Id,
    });
    toast.success("In-Person Meeting Request Accepted");
    closeModal();
  };
  const handleRejectMeeting = async () => {
    let Id = meetingData?.id;
    const receiver =
      selectedConvo.createdBy === user.UserID
        ? selectedConvo.customerId
        : selectedConvo.createdBy;
    let formData = {
      Title: meetingDetails.meetingTitle,
      messageId: meetingData.message_id,
      meetingDate: moment(meetingDetails.date).format("MMMM DD, YYYY"),
      meetingTime: moment(meetingDetails.time, "HH:mm").format("hh:mm A"),
      Address: meetingDetails.Address,
      // createdBy: meetingData.created_by,
      // receivedBy: meetingData.received_by,
      createdBy: user?.UserID,
      receivedBy: receiver,
      meetingStatus: "Rejected",
      Note: meetingDetails.notes,
      customerId: selectedConvo?.customerId,
      postId: selectedConvo?.Id,
      messageStatus: 17, // status for In-person meeting
      zoomStatus: 9, //create In-person meeting
    };
    await updateInPerson(Id, formData);
    const updateCurrent = {
      messageStatus: 17,
      zoomStatus: 9,
    };
    dispatch(updateSelectedConvoFields(updateCurrent));
    updateCurrentParent({
      ...updateCurrent,
      Id: selectedConvo.Id,
    });
    toast.success("In-Person Meeting Request Rejected");
    closeModal();
  };
  const handleReschedule = async () => {
    let Id = meetingData?.id;
    const receiver =
      selectedConvo.createdBy === user.UserID
        ? selectedConvo.customerId
        : selectedConvo.createdBy;
    let formData = {
      Title: meetingDetails.meetingTitle,
      messageId: meetingData.message_id,
      meetingDate: moment(meetingDetails.date).format("MMMM DD, YYYY"),
      meetingTime: moment(meetingDetails.time, "HH:mm").format("hh:mm A"),
      Address: meetingDetails.Address,
      // createdBy: meetingData.created_by,
      // receivedBy: meetingData.received_by,
      createdBy: user?.UserID,
      receivedBy: receiver,
      meetingStatus: "ReSchedule",
      Note: meetingDetails.notes,
      customerId: selectedConvo?.customerId,
      postId: selectedConvo?.Id,
      messageStatus: 19, // status for In-person meeting
      zoomStatus: 11, //create In-person meeting
    };
    console.log(formData, "handleReschedule");
    await updateInPerson(Id, formData);
    const updateCurrent = {
      messageStatus: 19,
      zoomStatus: 11,
    };
    dispatch(updateSelectedConvoFields(updateCurrent));
    updateCurrentParent({
      ...updateCurrent,
      Id: selectedConvo.Id,
    });
    selectedConvo?.createdBy !== user?.UserID &&
      logUser !== "provider" &&
      toast.success("Rescheduled In-Person Meeting");
    // if (selectedConvo?.createdBy === user?.UserID && logUser === "provider") {
    //   handleAcceptMeeting();
    // }
    closeModal();
  };

  // const handleComplete = async () => {
  //   let Id = meetingData?.id;
  //   const receiver =
  //     selectedConvo.createdBy === user.UserID
  //       ? selectedConvo.customerId
  //       : selectedConvo.createdBy;
  //   let formData = {
  //     Title: meetingData.title,
  //     messageId: meetingData.message_id,
  //     meetingDate: moment(meetingData.schedule_date).format("MMMM DD, YYYY"),
  //     meetingTime: moment(meetingData.schedule_time, "HH:mm").format("hh:mm A"),
  //     Address: meetingData.address,
  //     createdBy: user?.UserID,
  //     receivedBy: receiver,
  //     // createdBy: meetingData.created_by,
  //     // receivedBy: meetingData.received_by,
  //     meetingStatus: "Completed",
  //     Note: meetingData.note,
  //     customerId: selectedConvo?.customerId,
  //     postId: selectedConvo?.Id,
  //     messageStatus: 20, // status for In-person meeting
  //     zoomStatus: 12, //create In-person meeting
  //   };
  //   console.log(formData, "handleReschedule");
  //   await updateInPerson(Id, formData);
  //   const updateCurrent = {
  //     messageStatus: 20,
  //     zoomStatus: 12,
  //   };
  //   dispatch(updateSelectedConvoFields(updateCurrent));
  //   updateCurrentParent({
  //     ...updateCurrent,
  //     Id: selectedConvo.Id,
  //   });
  // };
 
  // useEffect(() => {
  //   const meetingDateTime = moment(
  //     `${meetingData?.schedule_date} ${meetingData?.schedule_time}`,
  //     "MMMM DD, YYYY hh:mm A"
  //   );
  //   const intervalId = setInterval(() => {
  //     const currentDateTime = moment();
  //     if (currentDateTime.isSameOrAfter(meetingDateTime)) {
  //       handleComplete();
  //       clearInterval(intervalId);
  //     }
  //   }, 1000);  

  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, [meetingData]);
  return (
    <Modal isOpen={isOpen} toggle={closeModal}>
      {updateInPersonMeeting === "List" && (
        <ModalHeader>
          {meetingData?.received_by === user?.UserID
            ? selectedConvo?.zoomStatus === 11
              ? "Reschdule Request sent"
              : "Request Sent for In-person Meeting"
            : selectedConvo?.zoomStatus === 11
            ? "Requested Reschedule"
            : "Requested for In-person Meeting"}
        </ModalHeader>
      )}
      <ModalBody>
        {updateInPersonMeeting === "Update" ||
        updateInPersonMeeting === "Create" ? (
          <>
            <FormGroup>
              <Label for="inPersonMeeting">
                Meeting Title <b className="text-danger">*</b>
              </Label>
              <Input
                type="text"
                id="meetingTitle"
                name="meetingTitle"
                placeholder="Meeting Title"
                value={meetingDetails.meetingTitle}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="inPersonMeeting">
                Address<b className="text-danger">*</b>
              </Label>
              <Input
                type="textarea"
                name="Address"
                id="Address"
                placeholder="Enter Address"
                value={meetingDetails.Address}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="inPersonMeeting">
                Select Date & Time <b className="text-danger">*</b>
              </Label>
              <Row>
                <Col>
                  <Input
                    type="date"
                    name="date"
                    id="date"
                    value={meetingDetails.date}
                    min={new Date().toISOString().split("T")[0]}
                    onChange={handleChange}
                  />
                </Col>
                <Col>
                  <Input
                    type="time"
                    name="time"
                    id="time"
                    value={meetingDetails.time}
                    onChange={handleChange}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Label for="inPersonMeeting">Notes (if applicable)</Label>
              <Input
                type="textarea"
                name="notes"
                id="notes"
                value={meetingDetails.notes}
                onChange={handleChange}
              />
            </FormGroup>
          </>
        ) : (
          updateInPersonMeeting === "List" && (
            <>
              <div className="text-center my-3">
                {/* <h5>
                  {meetingData?.received_by === user?.UserID
                    ? "Request Sent for In-person Meeting"
                    : "Requested for In-person Meeting"}
                </h5> */}
                <span>
                  <b>Meeting Title:</b> {meetingData?.title}
                </span>
                <br />
                <span>
                  <b>Address:</b> {meetingData?.address}
                </span>
                <br />
                <span>
                  <b>Meeting Time: </b>
                  {moment(
                    `${meetingData?.schedule_date} ${meetingData?.schedule_time}`
                  ).format("lll")}
                </span>
                <br />
                {meetingData?.note && (
                  <span>
                    <b>Optional Notes: </b>
                    {meetingData?.note}
                  </span>
                )}
              </div>
            </>
          )
        )}
      </ModalBody>
      <div className="text-end">
        {updateInPersonMeeting === "List" ? (
          <ModalFooter>
            {meetingData?.received_by === user?.UserID &&
              ((selectedConvo?.zoomStatus !== 9 &&
                selectedConvo?.zoomStatus !== 10) ||
                selectedConvo?.zoomStatus === 11) && (
                <>
                  <Button
                    color="success"
                    className="mx-1"
                    onClick={handleAcceptMeeting}
                  >
                    Accept
                  </Button>
                  <Button
                    color="danger"
                    className="mx-1"
                    onClick={handleRejectMeeting}
                  >
                    Reject
                  </Button>
                </>
              )}
            {selectedConvo?.zoomStatus === 10 && (
              <Button
                color="danger"
                className="mx-1"
                onClick={handleRejectMeeting}
              >
                Reject
              </Button>
            )}
            <Button
              color="warning"
              className="mx-1"
              onClick={() => setUpdateInPersonMeeting("Update")}
            >
              {selectedConvo?.zoomStatus === 9
                ? "Schedule again"
                : "Reschedule"}
            </Button>
          </ModalFooter>
        ) : updateInPersonMeeting === "Update" ? (
          <div className="mb-3">
            <Button
              color="danger"
              className="mx-1"
              onClick={() => setUpdateInPersonMeeting("List")}
              disabled={submitting}
            >
              Back
            </Button>
            <Button color="warning" className="mx-1" onClick={handleReschedule}>
              {/* Reschedule */}
              {submitting ? "Rescheduling..." : "Reschedule"}
            </Button>
          </div>
        ) : (
          <Button color="primary" className="mb-3 me-3" onClick={handleSubmit}>
            {/* Submit */}
            {submitting ? "Submitting..." : "Submit"}
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default InPersonMeetingModal;
